/* app/ui/filter/filter */

define(
	'app/ui/filter/filter',[
		'jquery'
	],

	function ($) {
		var selectors = {
			filter: '.js-filter',
			sectionTrigger: '.js-filter__expand-collapse'
		};

		var dataSelectors = {
			expandedDefault: 'filter-expanded-default'
		};

		var module = {
			init: function () {
				module._setAllDefaultState();
			},

			_setAllDefaultState: function () {
				var pageSize = window.outerWidth;
				var $filters;

				if (pageSize >= 1024) {
					$filter = $(selectors.filter);
					$filter.each(module._setFilterDefaultState);
				}
			},

			_setFilterDefaultState: function (i, el) {
				var $filter = $(el);
				var $sectionTrigger = $filter.find(selectors.sectionTrigger);

				$sectionTrigger.each(module._setSectionTriggerDefaultState);
			},

			_setSectionTriggerDefaultState: function (i, el) {
				var $sectionTrigger = $(el);

				if ($sectionTrigger.data(dataSelectors.expandedDefault)) {
					$sectionTrigger.trigger('click');
				}
			}
		};

		return {
			init: module.init
		};
	}
);

